import { Component, HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-home-fourteen',
  templateUrl: './home-fourteen.component.html',
  styleUrl: './home-fourteen.component.css'
})
export class HomeFourteenComponent {
  isSticky: boolean = false;
  logo: string = 'assets/images/logo-white.png';

    
  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollTop > 100) {  
      this.isSticky = true;
      this.logo = 'assets/images/logo-black.png';
    } else {
      this.isSticky = false;
      this.logo = 'assets/images/logo-white.png';
    }
  }

  isCollapsed = true;

  // OWl Slider
    customOptions: OwlOptions = {
      loop: true,
      dots: true,
      margin:0,
      nav:false,
      autoplay:false,
      autoplaySpeed: 2000,
      navSpeed: 2000,
      items: 1,
      navText: ['<i class="icofont icofont-arrow-left"></i>', '<i class="icofont icofont-arrow-right"></i>'],
    }
  
    slideStore = [
      {
        introtext: "Reimagine Your Wardrobe",
        title: "50% Discount",
        subtitle: "Shop Designer Brands & More",
        image: "assets/images/slides/home-bg-29.jpg",
        btnSlide: "btn btn-md btn-yellow btn-square mt-30",
        btnText: "Get Started",
      },
  
      {
        introtext: "Fashion Beyond Trends",
        title: "80% Off",
        subtitle: "Fall in Love with Fashion Again",
        image: "assets/images/slides/home-bg-30.jpg",
        btnSlide: "btn btn-md btn-yellow btn-square mt-30",
        btnText: "Get Started",
      },
  
      {
        introtext: "Dress Up Your Life",
        title: "Free Shipping on All Orders",
        image: "assets/images/slides/home-bg-31.jpg",
        btnSlide: "btn btn-md btn-yellow btn-square mt-30",
        btnText: "Get Started",
      }
  
    ]

  // Features
  
  features = [
    {
      url:'/home-fourteen',
      img: 'banner-02.jpg',
      title: 'Demin Jeans'
    },
    {
      url:'/home-fourteen',
      img: 'banner-03.jpg',
      title: 'Sunglasses'
    },
    {
      url:'/home-fourteen',
      img: 'banner-04.jpg',
      title: 'Footwear'
    },
    {
      url:'/home-fourteen',
      img: 'banner-05.jpg',
      title: 'Man Collection'
    }
  ]

  shopItem = [
    {
      url: '/home-fourteen',
      img:'product-01.jpg',
      title: 'Stitchout Boot',
      priceClass: 'beam-product-price-price',
      priceTxtNew: 25.00,
      priceClassOld: 'beam-product-price-price price-old',
      priceTxtOld: 40.00,
      labels: ['new', 'hot', '-50%'],
    },
    {
      url: '/home-fourteen',
      img:'product-02.jpg',
      title: 'Baseball Cap',
      priceClass: 'beam-product-price-price',
      priceTxtNew: 15.00,
      priceClassOld: 'beam-product-price-price price-old',
      priceTxtOld: 30.00,
      labels: ['hot'],
    },
    {
      url: '/home-fourteen',
      img:'product-03.jpg',
      title: 'Sun Glasses',
      priceClass: 'beam-product-price-price',
      priceTxtNew: 179.00,
      priceClassOld: 'beam-product-price-price price-old',
      priceTxtOld: 199.00,
    },
    {
      url: '/home-fourteen',
      img:'product-04.jpg',
      title: 'white Skirt',
      priceClass: 'beam-product-price-price',
      priceTxtNew: 200.00,
      priceClassOld: 'beam-product-price-price price-old',
      priceTxtOld: 250.00,
      labels: ['new', '-50%'],
    },
    {
      url: '/home-fourteen',
      img:'product-05.jpg',
      title: 'Slim indigo Shirt',
      priceClass: 'beam-product-price-price',
      priceTxtNew: 100.00,
      priceClassOld: 'beam-product-price-price',
      labels: ['-70%']
    },
    {
      url: '/home-fourteen',
      img:'product-06.jpg',
      title: 'Striped Shirt',
      priceClass: 'beam-product-price-price',
      priceTxtNew: 75.00,
      priceClassOld: 'beam-product-price-price'
    },
    {
      url: '/home-fourteen',
      img:'product-07.jpg',
      title: 'Casual T-Shirt',
      priceClass: 'beam-product-price-price',
      priceTxtNew: 64.00,
      priceClassOld: 'beam-product-price-price price-old',
      priceTxtOld: 80.00,
      labels: ['new', 'hot', '-50%'],
    },
    {
      url: '/home-fourteen',
      img:'product-08.jpg',
      title: 'Jackie Shell',
      priceClass: 'beam-product-price-price',
      priceTxtNew: 44.00,
      priceClassOld: 'beam-product-price-price price-old',
      priceTxtOld: 65.00,
      labels: ['hot'],
    }
  ];

  banners = [
    {
      img: 'banner-06.jpg',
      offText: '50% Off',
      title: 'Leather Totebag'
    },
    {
      img: 'banner-07.jpg',
      offText: '50% Off',
      title: 'Casual Shoes'
    }
  ]
}
